import { AppComponent } from './app.component';
import { EPResponse, EmployeeValidationData } from './models/model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApiServiceService {

  constructor(private httpClient: HttpClient) { }

  private getHeader() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      }),
    };
    return httpOptions;
  }

  private getUrl(): string {
    if (location.hostname.includes('localhost')) {
      return 'http://localhost:8080';
    } else if (location.hostname.includes('127.0.0.1')) {
      return 'https://buyalenovo.com';
    } else if (location.hostname.includes('hashconnect.in')) {
      return 'https://lenovo1.hashconnect.in';
    } else if (location.hostname.includes('buyalenovo.com')) {
      return 'https://buyalenovo.com';
    } else if (location.hostname.includes('lenovo.com')) {
      return 'https://buyalenovo.com';
    }
  }

  public validateEmployee(employeeData: EmployeeValidationData, program: string): Promise<EPResponse> {
    return this.httpClient.post("/rest/service/epap/employee/validate/" + program, { "employee": employeeData }, this.getHeader())
      .toPromise().then<EPResponse>()
      .catch((err) => {
        return Promise.reject<EPResponse>(err.desc);
      });

  }

  public resendOTP(employeeData: EmployeeValidationData, program: string): Promise<EPResponse> {
    return this.httpClient.post("/rest/service/epap/employee/resendotp/" + program, { "employee": employeeData }, this.getHeader())
      .toPromise().then<EPResponse>()
      .catch((err) => {
        return Promise.reject<EPResponse>(err.desc);
      });

  }

  public registerEmployeeForEffoer(data: EPResponse): Promise<EPResponse> {
    return this.httpClient.post("/rest/service/epap/employee/registerEP", data, this.getHeader())
      .toPromise().then<EPResponse>()
      .catch((err) => {
        return Promise.reject<EPResponse>(err.desc);
      });

  }

  public validateEmployeeWithOPTForAPOffer(data: EPResponse): Promise<EPResponse> {
    return this.httpClient.post("/rest/service/epap/employee/validateAPOTP", data, this.getHeader())
      .toPromise().then<EPResponse>()
      .catch((err) => {
        return Promise.reject<EPResponse>(err.desc);
      });

  }

  public registerAP(data: EPResponse): Promise<EPResponse> {
    return this.httpClient.post("/rest/service/epap/employee/registerAP", data, this.getHeader())
      .toPromise().then<EPResponse>()
      .catch((err) => {
        return Promise.reject<EPResponse>(err.desc);
      });

  }
}
